import React from 'react';
import { Link } from 'react-router-dom';

const LoginButton: React.FC = () => {
  return (
    <div className="hidden md:flex">
      <Link
        to="/login"
        className="inline-block lg:text-sm xl:text-base lg:py-2 xl:py-2 px-8 lg:px-12 xl:px-14 bg-navgreen text-white font-medium rounded-md  transition-all duration-300 hover:shadow-lg transform hover:scale-105"
      >
        Login
      </Link>
    </div>
  );
};

export default LoginButton;